// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__90SuJ","container":"style_container__pS9Ub","frame":"style_frame__mxlGP","content":"style_content__PVO5M"};